module.exports = __webpack_public_path__ + "delivery_truck_blue.e7f80e60dc116e1af2314b6d040f43f6.svg";